import { call, takeEvery } from 'redux-saga/effects'

import { route } from '../../api'
import { ADD_FAVORITE, REMOVE_FAVORITE } from './actions'

/**
 * Add a route to favorites.
 * @param {Object} action
 */
function* addFavorite({ routeId }) {
    try {
        yield call(route.favor, routeId)
    } catch (error) {
        yield call(console.error, error.message)
    }
}

/**
 * Remove a route from favorites.
 * @param {Object} action
 */
function* removeFavorite({ routeId }) {
    try {
        yield call(route.unfavor, routeId)
    } catch (error) {
        yield call(console.error, error.message)
    }
}

/**
 * Saga for basic list functionality.
 */
export function* routesSaga() {
    // Favor or unfavor routes
    yield takeEvery(ADD_FAVORITE, addFavorite)
    yield takeEvery(REMOVE_FAVORITE, removeFavorite)
}
